var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, Typography } from '@mui/material';
import { usePreviewLoop } from 'hx-din-test-2';
import { StepLayout } from './step-layout.component';
import { pageImages } from '@/pages/images';
import { VolumeSelectContent } from './volume-select-content.component';
import { InformationToggle } from './information-toggle.component';
import { palette } from '@/theme/palette';
import { LogoAndHeading } from './logo-and-heading.component';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
export function VolumeSelect() {
    var state = usePreviewLoop().dinPlayer.state;
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    if (state.status === 'initializing')
        return (_jsx("div", __assign({ className: "grid w-full h-full place-items-center" }, { children: _jsx(CircularProgress, {}) })));
    return (_jsx(StepLayout, { image: pageImages.headphonesBlack, heading: _jsx(LogoAndHeading, { headingText: 'Adjust the volume to a comfortable listening level.', image: {
                height: 110,
                width: 118,
            }, className: "text-lg md:text-2xl" }), progress: {
            phase: 0,
            step: 6,
        }, content: _jsx(VolumeSelectContent, {}), info: _jsx(InformationToggle, __assign({ title: 'What is a comfortable listening level?', chevronColor: palette.primary.main, onClick: function () {
                return handleSendButtonClick('what_is_comfortable_listening_level');
            } }, { children: _jsx(Typography, __assign({ className: 'text-xs md:text-base' }, { children: "Please find a comfortable listening level somewhere near the middle of your volume range. You should be able to clearly hear words being spoken. Setting the volume levels \u201Ctoo loud\u201D or \u201Ctoo quiet\u201D will risk the accuracy of your assessment results. Somewhere in the middle is best." })) })) }));
}
